import { createFileRoute } from "@tanstack/react-router";
import { CatalogPage } from "@/pages/CatalogPage";

/** A link can open the Catalog on a product (?product=<id>): Agent Rocket's link on a published product. */
export interface CatalogSearch { product?: string }

export const Route = createFileRoute("/_authenticated/catalog")({
  validateSearch: (search: Record<string, unknown>): CatalogSearch => ({ product: typeof search.product === "string" ? search.product : undefined }),
  head: () => ({
    meta: [
      { title: "Catalog · Oxley" },
      { name: "description", content: "Your products, features and versions." },
      { property: "og:title", content: "Catalog · Oxley" },
      { property: "og:description", content: "Your products, features and versions." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: CatalogPage,
});
